import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { PageTitle } from '../components/RouteTitle';
import { guestToken, saveGuestOrder, apiErrorMessage } from '../utils/guestOrders';
import { ordersAPI } from '../services/api';
import ThankYou from './ThankYou';

export default function GuestOrder() {
  const { orderId } = useParams();
  const [key, setKey] = useState(guestToken(orderId));
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const load = async e => {
    e?.preventDefault(); setError(''); setLoading(true);
    try {
      saveGuestOrder({ order_id: orderId, items: [] }, key);
      const data = await ordersAPI.getById(orderId);
      saveGuestOrder(data, key); setOrder(data);
    } catch (err) { setError(apiErrorMessage(err)); } finally { setLoading(false); }
  };
  useEffect(() => { if (key) load(); }, [orderId]); // capability stays out of the URL and tracking data
  return <><PageTitle title="Consultar pedido" />{order ? <ThankYou orderOverride={order} /> : <div className="max-w-md mx-auto px-4 py-14" data-testid="guest-order-access">
    <h1 className="text-3xl font-bold mb-6">Consultar mi pedido</h1>
    <p className="text-sm text-gray-600 break-all mb-6" data-testid="guest-order-access-id">Pedido {orderId}</p>
    <form onSubmit={load} className="space-y-4"><Label htmlFor="guest-access-key">Clave privada del pedido</Label><Input id="guest-access-key" type="password" value={key} onChange={e => setKey(e.target.value.trim())} required data-testid="guest-access-key" />
      {error && <p role="alert" className="text-red-700 text-sm" data-testid="guest-access-error">{error}</p>}
      <Button disabled={loading || !key} className="w-full bg-orange-500 hover:bg-orange-600" data-testid="guest-access-submit">{loading ? 'Consultando…' : 'Ver pedido'}</Button>
    </form>
  </div>}</>;
}